import React from "react";
import { Lock, Globe } from "lucide-react";
import { cn } from "@/utils/utils";

interface FileAccessIconBadgeProps {
  isPublic?: boolean;
  className?: string;
}

// Icon-only variant for use as overlay badge on file icons
export const FileAccessIconBadge: React.FC<FileAccessIconBadgeProps> = ({
  isPublic = false,
  className,
}) => {
  const Icon = isPublic ? Globe : Lock;
  const bgColor = isPublic ? "bg-green-500" : "bg-amber-500";

  return (
    <div
      className={cn(
        "absolute -bottom-1 -right-1 rounded-full p-0.5",
        bgColor,
        className,
      )}
    >
      <Icon className="h-3 w-3 text-white" />
    </div>
  );
};
